import { DeprecatedBreakpoint } from 'js/design_system/DeprecatedBreakpoint';
import useScreenSize from './useScreenSize';

/**
 * @deprecated Use `useInBreakpoints` from `js/design_system/hooks/useBreakpoint` instead.
 *
 * Returns `true` if `window.innerWidth` is less than
 * or equal to the specified breakpoint.
 *
 * ## Basic Usage
 *
 * @example
 * ```
 * import { Breakpoint } from 'js/design_system/Breakpoint';
 * import { useMediaQuery } from 'js/utils/hooks';
 *
 * const MyComponent = () => {
 *   const isMobile = useMediaQuery(Breakpoint.mobileSm);
 * };
 * ```
 */
const useDeprecatedMediaQuery = (breakpoint: DeprecatedBreakpoint): boolean => {
  const { screenWidth } = useScreenSize();
  return screenWidth <= breakpoint;
};

export default useDeprecatedMediaQuery;
